import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/web-api/web-api.service';
import { QueryResponseDataConverterService } from './convert/query-response-data-converter.service';
import { Query } from '../DTO/querying/query';
import { map, concatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QueryService {

  constructor(private webApiService: WebApiService, private converterService: QueryResponseDataConverterService) { }

  postDataGridQuery(gridId: string, query: Query) {
    return this.webApiService.post<any>(`/data/query/grid/${gridId}`, query);
  }

  postQuery<T>(query) {
    return this.webApiService.post<T>(`/data/query`, query);
  }

  postQueryAndConvertResponse<T>(query, type) {
    return this.postQuery<T[]>(query).pipe(
      concatMap(array => array),
      map(data => {
        return this.converter<T>(data, type);
      })
    );
  }

  converter<T>(data, type) {
    return this.converterService.converter<T>(data, type);
  }
}
